import { LeftHeader } from 'admin/components/leftHeader';
import { MainLayoutWrapper } from 'admin/layout/styled';
import { DashboardWrapper, MainDashboard } from 'admin/containers/Home/styled';

export const MainAdminLayout = ({ children }) => (
  <MainLayoutWrapper>
    <LeftHeader />
    <DashboardWrapper>
      <MainDashboard>{children}</MainDashboard>
    </DashboardWrapper>
  </MainLayoutWrapper>
);
